import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';

import { CircleProgress } from '@/components/CircleProgress';
import { ReviewCards } from '@/components/ReviewCards';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { useOnboarding } from '@/pages/Onboarding/context';
import { useQueryPersonalizedAis } from '@/pages/Onboarding/hooks/useQueryPersonalizedAis';
import { canLogEvents } from '@/utils/canLogEvents';
import { preloadImage } from '@/utils/preloadImage';

import { LayoutDataType } from '../../types';

const ScreenPersonalizingFeedStyles = styled(OnboardingPage)`
  ion-content {
    .progress-circle {
      margin: 48px auto 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .user-reviews {
      margin: 24px 0 0;
    }
  }
`;

export const ScreenPersonalizingFeed: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Personalizing Feed',
      });
    }
  }, []);

  const [hideNextButton, setHideNextButton] = React.useState(true);

  const onSuccess = () => {
    setHideNextButton(false);
  };

  const [enableQuery, setEnableQuery] = React.useState(false);

  React.useEffect(() => {
    setTimeout(() => {
      setEnableQuery(true);
    }, 2000);
  });

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  useQueryPersonalizedAis({
    enabled: enableQuery,
    form,
    onSuccess: (data) => {
      form.setValue('characters', data.twins);

      data.twins.forEach((twin) => {
        preloadImage(twin.profile_picture_url);
      });
    },
  });

  return (
    <ScreenPersonalizingFeedStyles>
      <IonContent>
        <CircleProgress
          className="progress-circle"
          size={220}
          strokeWidth={10}
          onFinish={onSuccess}
          key="personalizing-feed-progress"
        />
        <OnboardingTitle>
          Preparing the stage for your AI adventure. Almost there!
        </OnboardingTitle>

        <section className="user-reviews">
          <ReviewCards />
        </section>
      </IonContent>

      <OnboardingFooter hidden={hideNextButton} onContinue={wizard.nextStep} />
    </ScreenPersonalizingFeedStyles>
  );
};
